var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailerr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    width: 454,
    height: 454,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 454.8 454.8",
    style: {
      enableBackground: "new 0 0 454.8 454.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M442.3,146.4H176.8c-6.9,0-12.5,5.6-12.5,12.5V291H155V172.9v-45.5h2.7c6.9,0,12.5-5.6,12.5-12.5 s-5.6-12.5-12.5-12.5h-15.2c-6.9,0-12.5,5.6-12.5,12.5v47.2l-61.3,8.8c-5.9,0.8-10.3,5.7-10.7,11.6l-2,32.2l-46.1,10 C4.1,226,0,231,0,236.9v66.6c0,6.9,5.6,12.5,12.5,12.5h50.5c2.3,20.5,19.7,36.4,40.7,36.4c21.1,0,38.4-16,40.7-36.4l139.5,0 c2.3,20.5,19.7,36.4,40.7,36.4c11.1,0,21.1-4.4,28.5-11.6c7.4,7.1,17.4,11.6,28.5,11.6c21.1,0,38.4-16,40.7-36.4h19.9 c6.9,0,12.5-5.6,12.5-12.5V158.9C454.8,152,449.2,146.4,442.3,146.4L442.3,146.4z M90.9,193v19.4h-9.7l1.1-18.2L90.9,193L90.9,193z  M25,247l44.2-9.6h34.2c6.9,0,12.5-5.6,12.5-12.5v-35.5l14.1-2v92.6c-7.1-5.9-16.3-9.5-26.2-9.5c-15.2,0-28.4,8.3-35.5,20.6H25 C25,291,25,247,25,247z M103.8,327.4c-8.8,0-16-7.2-16-16c0-8.8,7.2-16,16-16s16,7.2,16,16C119.8,320.2,112.6,327.4,103.8,327.4z  M324.7,327.4c-8.8,0-16-7.2-16-16c0-8.8,7.2-16,16-16s16,7.2,16,16C340.7,320.2,333.6,327.4,324.7,327.4z M381.7,327.4 c-8.8,0-16-7.2-16-16c0-8.8,7.2-16,16-16s16,7.2,16,16S390.5,327.4,381.7,327.4z M429.8,291h-12.6c-7.1-12.3-20.3-20.6-35.5-20.6 c-11.1,0-21.1,4.4-28.5,11.6c-7.4-7.1-17.4-11.6-28.5-11.6c-15.2,0-28.4,8.3-35.5,20.6h-99.9V171.4h240.5L429.8,291L429.8,291z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailerr);
export default __webpack_public_path__ + "static/media/trailerr.f951d17ea9fc28ff9c539923e818ed95.svg";
export { ForwardRef as ReactComponent };